import { ListPagerComponent } from '../../components/list-pager/list-pager.component';
import { TableTransactionsComponent } from '../../components/table-transactions/table-transactions.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';

@Component({
	standalone: true,
	selector: 'card-transactions',
	templateUrl: './card-transactions.component.html',
	imports: [ CommonModule, ListPagerComponent, TableTransactionsComponent, FormsModule ]
})
export class CardTransactionsComponent implements OnInit {
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() pageSize: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.transactions = [];
		this.vm.pageSize = 10;
	}
	
	currentPageChanged(newPage) {
		this.vm.currentPage = newPage;
		this.angularBroadcastHelperService.rootBroadcast("loadMorePages", newPage);
	}
	
}